const { Button } = require("reactstrap")

const CustomButton = ({ text, onClick }) => {
    return <Button
        color="primary"
        outline
        className="waves-effect waves-light me-2 bg-primary text-white rounded-3"
        onClick={onClick}
    >
        {text}
    </Button>
}

export { CustomButton };